import axios from '@/api/config';

const newsCenter = {


    addNotice(data) {
        return axios.post(`${process.env.BASE_URL}/notice/addNotice`, data);
    },

    pageList(data) {
        return axios.post(`${process.env.BASE_URL}/notice/pageList`, data);
    },
    getAgentInfoList(data) {
        return axios.get(`${process.env.BASE_URL}/notice/getAgentInfoList`, { params: data });
    },
    deleteNotice(data) {
        return axios.delete(`${process.env.BASE_URL}/notice/deleteNotice`, { data: data });
    },
//通知详情
    getNotice(data) {
        return axios.get(`${process.env.BASE_URL}/notice/getNotice`, {params: data});
    },
    //编辑消息

    updateNotice(data) {
    return axios.put(`${process.env.BASE_URL}/notice/updateNotice`, data);
  },




};

export default newsCenter;



// WEBPACK FOOTER //
// ./src/api/newsCenter.js